"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _ActionTypes = _interopRequireDefault(require("composer-lib/redux/ActionTypes"));

var _constants = require("composer-lib/lib/constants");

var _UserAttributes = _interopRequireDefault(require("composer-lib/data/model/UserAttributes"));

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _UserAttributes.default();
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _ActionTypes.default.FETCH_USER_ATTRIBUTES_PENDING:
      return state.set('status', _constants.RequestStatus.PENDING);

    case _ActionTypes.default.FETCH_USER_ATTRIBUTES_SUCCEEDED:
      return _UserAttributes.default.fromJS(action.data);

    case _ActionTypes.default.FETCH_USER_ATTRIBUTES_FAILED:
    case _ActionTypes.default.UPDATE_USER_ATTRIBUTE_FAILED:
      return state.set('status', _constants.RequestStatus.FAILED);

    case _ActionTypes.default.UPDATE_USER_ATTRIBUTE_PENDING:
      return state.merge({
        data: (0, _defineProperty2.default)({}, action.data.key, action.data.value),
        status: _constants.RequestStatus.PENDING
      });

    case _ActionTypes.default.UPDATE_USER_ATTRIBUTE_SUCCEEDED:
      return state.setIn(['data', action.data.key], _UserAttributes.default.prepareAttributeValue(action.data.value));

    default:
      return state;
  }
};

exports.default = _default;
module.exports = exports.default;